import {h} from 'preact';
import {GetCustomer} from '@services/Customer/query.graphql';
import {Query} from 'react-apollo';
import UEStatus from '@components/account/ultradent-elite/UEStatus';
import pathOr from 'ramda/src/pathOr';

const withQuery = ( Component ) => {
    function Wrapper ( props ) {
        return (
            <Query query={GetCustomer} variables={{withEliteStatus: true}}>
                {UEStatusQuery( props )}
            </Query>
        );
    }

    Wrapper.displayName = `withQuery(${Component.displayName || Component.name})`

    return Wrapper;
};

export const UEStatusQuery = ( props = {} ) => ( {data, loading, error} ) => {
    if ( loading ) {
        return <UEStatus.Loading {...props}/>
    }
    if ( error || !data ) {
        return null;
    }

    const ueStatus = pathOr( {}, ['customer', 'eliteStatus'], data );

    return <UEStatus.Content loading={loading} ueStatus={ueStatus} {...props} />;
};

export default withQuery( UEStatus );
